export const EMAIL_REGEX = /^[\w]{1,}[\w.+-]{0,}@[\w-]{2,}([.][a-zA-Z]{2,}|[.][\w-]{2,}[.][a-zA-Z]{2,})$/;



// WEBPACK FOOTER //
// ./src/constants.ts